import { Descriptions } from "antd";
import styled from "styled-components";

const CustomDescriptions = styled(Descriptions)`
  &.ant-descriptions:not(.ant-descriptions-bordered) {
    & .ant-descriptions-item-label {
      /* Body/Body 7 M - 15 */
      font-size: 15px;
      font-weight: 500;
      line-height: 20px; /* 133.333% */
      color: ${({ theme }) => theme.color.gray5};
    }
    & .ant-descriptions-item-content {
      /* Body/Body 7 M - 15 */
      font-size: 15px;
      font-weight: 500;
      line-height: 20px; /* 133.333% */
    }
  }
  &.ant-descriptions.info {
    & .ant-descriptions-item-content {
      font-weight: 400;
    }
  }

  & .ant-descriptions-item-label {
    font-size: 15px;
    font-weight: 500;
    line-height: 20px; /* 133.333% */
  }

  & tr:has(th:not(.ant-descriptions-item-label)) {
    border: 0;
  }
  & th:not(.ant-descriptions-item-label) {
    padding: 0;
  }

  & tr:has(td.noPad.empty) {
    /* border: 0; */
  }

  & td.noPad {
    padding: 0;
  }
`;

export { CustomDescriptions };
